import { useState } from "react";
import { C } from "../constants/colors";

const PAID_PLANS = ['practice', 'professional', 'emerging', 'established'];

export function TrialBanner({ userType, onUpgrade, onSubscribe, trialEndsAt, plan, subscriptionStatus, subscribing }) {
  const [dismissed, setDismissed] = useState(false);

  // Active paid subscriber — hide entirely
  if (subscriptionStatus === 'active') return null;
  // Artist with a paid plan (plan-based check, no subscriptionStatus for artists)
  if (!subscriptionStatus && PAID_PLANS.includes(plan)) return null;
  // No trial data at all
  if (!trialEndsAt) return null;

  const daysLeft = Math.ceil((new Date(trialEndsAt) - new Date()) / 86400000);
  const trialExpired = daysLeft <= 0;

  // ── Expired: persistent, non-dismissable ──────────────────────────────────
  if (trialExpired) {
    return (
      <div className="trial-banner">
        <div style={{ fontFamily:"'DM Mono',monospace",fontSize:".6rem",color:C.rose,letterSpacing:"2px",textTransform:"uppercase",background:"rgba(193,91,74,.2)",padding:"4px 10px",borderRadius:20,flexShrink:0 }}>
          Trial ended
        </div>
        <div style={{ flex:1,fontSize:".8rem",color:"rgba(196,168,130,.8)",lineHeight:1.5 }}>
          Your free trial has ended. Upgrade to keep posting open calls.
        </div>
        {onSubscribe ? (
          <div style={{ display:"flex",gap:8,flexShrink:0 }}>
            <button
              className="btn-g"
              style={{ fontSize:".64rem",padding:"8px 12px",minHeight:38,whiteSpace:"nowrap" }}
              onClick={() => onSubscribe('emerging')}
              disabled={!!subscribing}
            >
              {subscribing === 'emerging' ? 'Redirecting…' : 'Emerging $79/mo'}
            </button>
            <button
              className="btn-p"
              style={{ fontSize:".64rem",padding:"8px 12px",minHeight:38,whiteSpace:"nowrap" }}
              onClick={() => onSubscribe('established')}
              disabled={!!subscribing}
            >
              {subscribing === 'established' ? 'Redirecting…' : 'Established $149/mo'}
            </button>
          </div>
        ) : (
          <button className="btn-p" style={{ fontSize:".68rem",padding:"8px 14px",minHeight:38,flexShrink:0 }} onClick={onUpgrade}>
            Upgrade now
          </button>
        )}
      </div>
    );
  }

  // ── Active trial: dismissable ─────────────────────────────────────────────
  if (dismissed) return null;

  const label = `${daysLeft} day${daysLeft !== 1 ? 's' : ''} left`;

  return (
    <div className="trial-banner">
      <div style={{ fontFamily:"'DM Mono',monospace",fontSize:".6rem",color:C.clay,letterSpacing:"2px",textTransform:"uppercase",background:"rgba(193,127,74,.2)",padding:"4px 10px",borderRadius:20,flexShrink:0 }}>{label}</div>
      <div style={{ flex:1,fontSize:".8rem",color:"rgba(196,168,130,.8)",lineHeight:1.5 }}>
        Your free trial of the <strong style={{ color:"#f0e2cc" }}>{userType==="gallery"?"Established":"Practice"}</strong> plan ends in {daysLeft} day{daysLeft !== 1 ? 's' : ''}.
      </div>
      <button
        className="btn-p"
        style={{ fontSize:".68rem",padding:"8px 14px",minHeight:38,flexShrink:0 }}
        onClick={onUpgrade || (() => onSubscribe?.('emerging'))}
      >
        Upgrade now
      </button>
      <button
        onClick={() => setDismissed(true)}
        style={{ background:"none",border:"none",color:"rgba(196,168,130,.4)",fontSize:".9rem",cursor:"pointer",flexShrink:0,minHeight:36,minWidth:36,display:"flex",alignItems:"center",justifyContent:"center" }}
      >
        ✕
      </button>
    </div>
  );
}
